import { render, staticRenderFns } from "./KycPersonPage.vue?vue&type=template&id=fc000966&"
import script from "./KycPersonPage.vue?vue&type=script&lang=js&"
export * from "./KycPersonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports